export default function getResource(label) {
    const resources = {
        inStore: 'In Store',
        sameDayDelivery: 'Same-Day Delivery',
        shipping: 'Shipping'
    };

    return resources[label];
}
